<template>
  <v-container
    style="height: 515px"
    class="overflow-y-auto overflow-x-hidden order-list-inside vuebar-element"
    v-bar="{ preventParentScroll: true, scrollThrottle: 30 }"
  >
    <div>
      <v-row
        v-for="(group, gindx) in list"
        :key="gindx"
        class="group-row"
        :class="(group.id === 0 ? 'unscheduled' : 'scheduled')"
      >
        <v-col cols="1" class="title-col">
          <span v-if="group.id === 0">{{ lang.orders.new.order.groups.no_group[catalog] }}</span>
          <div v-else class="actions">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  small
                  @click.stop="groupAction(group.id, 1)"
                  color="gray darken-2"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.orders.new.order.groups.actions.view }}</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  small
                  @click.stop="groupAction(group.id, 2)"
                  color="gray darken-2"
                >
                  <v-icon small>mdi-playlist-edit</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.orders.new.order.groups.actions.edit }}</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  small
                  @click.stop="groupAction(group.id, 3)"
                  color="gray darken-2"
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.orders.new.order.groups.actions.delete }}</span>
            </v-tooltip>
          </div>
        </v-col>
        <v-col cols="11" class="list-col">
          <v-row
            v-for="(item, index) in group.list"
            :key="index"
            @click="toggleSelected(item)"
            class="order-row"
            :class="{ 'selected': (selected[catalog].indexOf(item.UUID) > -1) }"
          >
            <v-col cols="1" class="actions-col">
              <div class="actions">
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      small
                      @click.stop="deleteItem(item.UUID)"
                      color="gray darken-2"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.orders.new.order.delete }}</span>
                </v-tooltip>
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      small
                      @click.stop="duplicateItem(item.UUID)"
                      color="gray darken-2"
                    >
                      <v-icon small>mdi-content-duplicate</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.orders.new.order.duplicate }}</span>
                </v-tooltip>
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      small
                      color="gray darken-2"
                      @click.stop="toggleField('adt', item.UUID)"
                    >
                      <v-icon small>mdi-playlist-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.orders.new.order.adt }}</span>
                </v-tooltip>
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      small
                      color="gray darken-2"
                      @click.stop="toggleField('obs', item.UUID)"
                    >
                      <v-icon small>mdi-comment</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ lang.orders.new.order.obs }}</span>
                </v-tooltip>
              </div>
            </v-col>
            <v-col cols="11" class="order-col">
              <v-row class="px-2">
                <v-col cols="1" class="qty-col">
                  <span class="item-qty">
                    <v-text-field
                      v-model="item.qty"
                      :label="lang.orders.new.qty"
                      @click:append-outer="item.qty++"
                      @click:prepend="(item.qty < 2 ? deleteItem(item.UUID) : item.qty--)"
                      append-outer-icon="mdi-menu-up"
                      prepend-icon="mdi-menu-down"
                      type="number"
                      hide-details
                      single-line
                      flat
                    ></v-text-field>
                  </span>
                </v-col>
                <v-col v-if="item.photo" cols="1" class="item-thumb">
                  <Thumb
                    :photo="item.photo"
                    :size="40"
                  />
                </v-col>
                <v-col
                  :cols="(item.photo ? 7 : 8)"
                  :lg="(item.photo ? 8 : 9)"
                  :md="(item.photo ? 8 : 9)"
                  :sm="(item.photo ? 7 : 8)"
                  class="item-content"
                  :class="{ 'has-thumb': (item.photo) }"
                >
                  <v-row class="title-row">
                    <p class="item-title">{{ `${(String(item.cod).trim().length > 0 ? '#' + String(item.cod).trim() + ' - ': '')}${getCat(item)} ${item.title} x${item.qty}` }}</p>
                  </v-row>
                  <v-row class="subtitle-row">
                    <span class="item-subtitle">{{ item.description }}</span>
                  </v-row>
                </v-col>
                <v-col cols="3" lg="2" md="2" sm="3" class="price-col">
                  <span class="item-price text-lg-right">{{ formatCurrency(item.total) }}</span>
                </v-col>
              </v-row>
              <v-row class="sub-row">
                <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="sub-col">
                  <v-subheader>{{ lang.orders.new.order.additional_un }}</v-subheader>
                  <template v-if="fields.adt.indexOf(item.UUID) < 0">
                    <v-container
                      v-if="(item.adt || []).length > 0"
                      class="adt-container"
                    >
                      <v-row
                        v-for="(adt, adt_i) in item.adt"
                        :key="adt_i"
                        class="adt-row"
                      >
                        {{ `- ${adt.title} x${adt.qty}` }}
                        <span class="adt-total">{{ formatCurrency(adt.total) }}</span>
                      </v-row>
                    </v-container>
                    <span
                      @click.stop="toggleField('adt', item.UUID)"
                      class="open-field"
                    >
                      {{ `${((item.adt || []).length > 0 ? lang.orders.new.order.edit : lang.orders.new.order.add)} ${lang.orders.new.order.additional}` }}
                    </span>
                  </template>
                  <template v-else>
                    <Additional
                      :value="item.adt"
                      :items="selectAdt(item.cat_id, item.parent_cat)"
                      :label="lang.orders.new.order.additional"
                      @input="(e) => updateAdt(e, item)"
                      @closed="toggleField('adt', item.UUID)"
                      v-click-outside="{ handler: closeAdtFields, include: include }"
                      :clearable="false"
                      returnObject
                      hideSelected
                    />
                  </template>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="sub-col">
                  <v-subheader>{{ lang.orders.new.order.obs }}</v-subheader>
                  <template v-if="fields.obs.indexOf(item.UUID) < 0">
                    <div
                      v-if="(item.obs && item.obs !== null)"
                      class="item-obs"
                    >
                      {{ item.obs }}
                    </div>
                    <span
                      @click.stop="toggleField('obs', item.UUID)"
                      class="open-field"
                    >
                      {{ `${(item.obs && item.obs !== null ? lang.orders.new.order.edit : lang.orders.new.order.add)} ${lang.orders.new.order.obs}` }}
                    </span>
                  </template>
                  <template v-else>
                    <v-textarea
                      v-model="item.obs"
                      prepend-inner-icon="mdi-close-circle"
                      @click:prepend-inner="closeField('obs', item.UUID)"
                      v-click-outside="closeObsFields"
                      label="..."
                      rows="1"
                      clear-icon="mdi-broom"
                      clearable
                      filled
                      auto-grow
                      hide-details
                    ></v-textarea>
                  </template>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Thumb from '@/components/catalog/items/templates/Thumb'
import Additional from './autocomplete/Additional'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Thumb, Additional },
  mixins: [ appdata, utils ],
  props: {
    catalog: {
      type: String,
      default: 'services'
    },
    value: {
      type: Object,
      default: () => {
        return { services: [], items: [] }
      }
    },
    groups: {
      type: Object,
      default: () => {
        return { services: [], items: [] }
      }
    }
  },
  data () {
    return {
      list: [],
      fields: {
        adt: [],
        obs: []
      },
      selected: {
        services: [],
        items: []
      }
    }
  },
  watch: {
    list: {
      deep: true,
      handler (newVal) {
        // console.log('changed list date')
        let list = this.generateList(newVal)
        if (JSON.stringify(list) !== JSON.stringify(this.value[this.catalog])) {
          // console.log('updated value')
          this.$emit('input', { list, catalog: this.catalog })
        }
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler (newVal) {
        // console.log('changed value prop')
        let list = this.generateGroups(newVal[this.catalog])
        if (JSON.stringify(this.list) !== JSON.stringify(list)) {
          // console.log('updated list')
          this.list = [ ...list ]
        }
      }
    },
    groups: {
      deep: true,
      immediate: true,
      handler () {
        setTimeout(function () {
          let list = this.generateGroups(this.value[this.catalog])
          if (JSON.stringify(this.list) !== JSON.stringify(list)) {
            // console.log('updated list')
            this.list = [ ...list ]
          }
        }.bind(this), 747)
      }
    },
    catalog (newVal) {
      this.list = [ ...this.value[newVal] ]
      this.$forceUpdate()
    }
  },
  methods: {
    generateGroups (value) {
      // console.log('gen groups')
      let groups = this.groups[this.catalog] || [],
          list = [ ...value ].map(obj => ({ ...obj })),
          grouped = list.reduce((r, a) => {
            let group = groups.find(el => (typeof el.delete === 'undefined' || el.delete < 1) && typeof el.list !== 'undefined' && el.list.findIndex(el_ => el_ === a.UUID) >= 0) || false,
                group_ = (group ? group.UUID : 0),
                exist = r.find(el => el.id === group_) || false,
                list_ = exist.list || []
            list_.push(a)
            let new_ = { id: group_, list: list_ }
            if (exist) {
              exist = new_
            } else {
              if (group_ !== 0) {
                r.unshift(new_)
              } else {
                r.push(new_)
              }
            }
            return r
          }, []),
          sorted = grouped.sort((a, b) => {
            var x = a.id; var y = b.id
            return ((x > y) ? -1 : ((x < y) ? 1 : 0))
          })
      return sorted
    },
    generateList (value) {
      // console.log('gen list')
      return [ ...value ].reduce((add, val) => add.concat(val.list), [])
    },
    toggleSelected (item) {
      let selected = this.selected[this.catalog] || false
      if (selected) {
        let slIndex = selected.indexOf(item.UUID)
        if (slIndex > -1) {
          return selected.splice(slIndex, 1)
        } else {
          return selected.push(item.UUID)
        }
      }
      return false
    },
    deselect (item) {
      let selected = this.selected[this.catalog] || []
      let slIndex = selected.indexOf(item.UUID)
      return (slIndex > -1 ? selected.splice(slIndex, 1) : false)
    },
    selectAll () {
      var new_sl = [],
          ungrouped = (this.list || []).find(group => group.id === 0) || []
      ungrouped.list.map((item) => {
        new_sl.push(item.UUID)
      })
      return this.$set(this.selected, this.catalog, [ ...new_sl ]) || false
    },
    deselectAll () {
      return this.$set(this.selected, this.catalog, []) || false
    },
    getCat (item) {
      item.cat_name = (item.cat_name || '')
      item.parent_cat_name = (item.parent_cat_name || '')
      if (item.cat) {
        return (item.parent_cat !== item.cat ? ` (${item.parent_cat_name} > ${item.cat_name})` : ` (${item.cat_name})`)
      }
      return ''
    },
    deleteItem (UUID) {
      const list = this.list || []
      list.forEach((group) => {
        group.list = (group.list || []).filter(item => item.UUID !== UUID)
      })
      this.deselect(UUID)
      this.$emit('action', { action: 4, value: { catalog: this.catalog, UUID } })
      return true
    },
    duplicateItem (UUID) {
      const list = this.list || []
      list.forEach((group) => {
        let item = (group.list || []).find(item => item.UUID !== UUID) || false
        if (item) {
          let new_ = { ...item }
          new_.UUID = this.getRandomUnique()
          group.list.push(new_)
        }
      })
    },
    selectAdt (cat, parentCat) {
      const additional = this.get_data.additional.filter(el => el.cat === cat || el.cat === parentCat)
      return additional || false
    },
    updateAdt (selected, item) {
      item.adt = [ ...selected ]
      this.$emit('input', { list: this.list, catalog: this.catalog })
    },
    removeAdt (UUID, adt) {
      const itemD = this.list.find(el => el.UUID === UUID)
      const currentAdt = itemD.adt
      const adtI = currentAdt.indexOf(adt)
      currentAdt.splice(adtI, 1)
      this.$emit('input', { list: this.list, catalog: this.catalog })
    },
    getField (field, UUID) {
      let fields = this.fields[field] || false
      return (fields ? (fields.indexOf(UUID) < 0) : false)
    },
    toggleField (field, UUID) {
      let fields = this.fields[field] || false
      const fieldsCopy = (fields ? [ ...fields ] : false)
      if (fieldsCopy) {
        let fieldIndex = fieldsCopy.indexOf(UUID)
        if (fieldIndex > -1) {
          fieldsCopy.splice(fieldIndex, 1)
        } else {
          fieldsCopy.push(UUID)
        }
        return this.$set(this.fields, field, [ ...fieldsCopy ]) || false
      }
      return false
    },
    closeField (field, UUID) {
      let fields = this.fields[field] || false
      let fieldIndex = fields.indexOf(UUID)
      return (fieldIndex > -1 ? fields.splice(fieldIndex, 1) : false)
    },
    closeAdtFields () {
      return this.$set(this.fields, 'adt', []) || false
    },
    closeObsFields () {
      return this.$set(this.fields, 'obs', []) || false
    },
    include () {
      return [ ...document.querySelectorAll('.v-autocomplete__content') ]
    },
    groupAction (UUID = 0, action = 0) {
      return this.$emit('action', { action, value: { catalog: this.catalog, UUID } })
    },
    busEvent ({ action, value }) {
      var rtrn = false
      if (value) {
        switch (action) {
          case 1:
            rtrn = this.selectAll()
            break
          case 2:
            rtrn = this.deselectAll()
            break
          case 3:
            rtrn = this.$emit('action', { action: 2, value: { catalog: this.catalog, UUID: 0, list: this.selected[this.catalog] || [] } })
            break
          case 4:
            rtrn = this.$emit('action', { action: 4, value: { catalog: this.catalog, UUID: value } })
            break
        }
        this.$forceUpdate()
      }
      return rtrn
    }
  },
  mounted () {
    const vm = this
    this.$root.$on('order-widget-list', vm.busEvent)
    setTimeout(function () {
      this.list = this.generateGroups(this.value[this.catalog])
      this.$forceUpdate()
    }.bind(this), 545)
  },
  beforeDestroy () {
    this.$root.$off('order-widget-list')
  }
}
</script>
